import { Component, OnInit } from '@angular/core';
import { StatusCategoryService } from '../status-category.service';
import { StatusCategory } from '../status-category';
import { Router } from '@angular/router';
import { NotificationService } from '../../shared/notification.service';

@Component({
  selector: 'app-status-category-create',
  templateUrl: 'create.component.html',
})
export class StatusCategoryCreateComponent implements OnInit {
  /**
   * Details of the statusCategory being created.
   */
  public statusCategory: StatusCategory;

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = false;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {StatusCategoryService} statusCategoryService
   * @param {NotificationService} notificationService
   * @param {Router} router
   */
  constructor(
    private statusCategoryService: StatusCategoryService,
    private notificationService: NotificationService,
    private router: Router,
  ) {
    this.statusCategoryService.loading.subscribe(
      result => (this.isLoading = result),
    );
  }

  /**
   * Initialise the component, creating a new blank statusCategory if required.
   */
  public ngOnInit(): void {
    if (!this.statusCategory) {
      this.statusCategory = new StatusCategory();
    }
  }

  /**
   * Perform the create action which adds the new statusCategory into the backend.
   */
  public create() {
    const createStatusCategory = this.statusCategoryService
      .createStatusCategory(this.statusCategory)
      .subscribe(
        (result: StatusCategory) => {
          this.notificationService.success(
            `StatusCategory Created`,
            `New statusCategory ${result.name} has been created with ID of ${
              result.id
            }.`,
            5,
          );
          this.statusCategory = new StatusCategory();
          createStatusCategory.unsubscribe();
          this.router.navigate(['/status-categories']);
        },
        err => {
          this.notificationService.error(
            `Could not create StatusCategory`,
            err.error.message,
            10,
          );
        },
      );
  }
}
